import React, {useMemo} from 'react';
import {
	LegacyFormSelectField,
	type LegacyFormSelectFieldProps,
} from '@netx/core-components/Form/SelectField';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormBaseFieldName,
	getCustomFormItemTranslatedLabel,
} from '../../utils';
import {getSelectOptionDisabled, getSelectOptionLabel} from './utils';

export interface LegacyFormCustomFormItemMultiselectProps
	extends Omit<
		LegacyFormSelectFieldProps<string, true, false, false>,
		'value' | 'label' | 'name' | 'required'
	> {
	item: ICustomFormItem<'multiselect'>;
	value?: string[];
}

export const LegacyFormCustomFormItemMultiselectPrimitive = ({
	item,
	value: _value,
	...props
}: LegacyFormCustomFormItemMultiselectProps) => {
	const {label, value, required, userValues} = item;

	if (typeof value === 'string') return null;

	const options = useMemo(() => {
		return value.reduce<string[]>((accum, val) => {
			if (typeof val === 'string') return [...accum, val];
			if (val.disabled && !(userValues as string[]).includes(val.key))
				return accum;
			return [...accum, val.key];
		}, []);
	}, [value, userValues]);

	return (
		<LegacyFormSelectField<string, true, false, false>
			fullWidth
			{...props}
			disabled={props.disabled || item.disabled}
			label={getCustomFormItemTranslatedLabel(label)}
			multiple
			name={getCustomFormBaseFieldName(item)}
			options={options}
			required={required}
			value={_value != null ? _value : []}
			getOptionDisabled={getSelectOptionDisabled(value)}
			getOptionLabel={getSelectOptionLabel(value)}
		/>
	);
};

export const LegacyFormCustomFormItemMultiselect =
	LegacyFormCustomFormItemMultiselectPrimitive;

export default LegacyFormCustomFormItemMultiselect;
